export default __webpack_public_path__ + "static/media/I0006.0d350ca4.png";